// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"41f0d81c","418":"ef335cb0","668":"e9a429e3"}[chunkId] + ".js";
};